module.exports = __webpack_public_path__ + "static/media/0.48e269c5.jpg";